import { render, staticRenderFns } from "./sales.vue?vue&type=template&id=dc4596d8&scoped=true"
import script from "./sales.vue?vue&type=script&lang=js"
export * from "./sales.vue?vue&type=script&lang=js"
import style0 from "./sales.vue?vue&type=style&index=0&id=dc4596d8&prod&lang=css"
import style1 from "./sales.vue?vue&type=style&index=1&id=dc4596d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc4596d8",
  null
  
)

export default component.exports